import { render } from "./settings.vue?vue&type=template&id=4d4677a3"
const script = {}
script.render = render

export default script